import useRedirectToCallback from '../../../utils/callbackUrl/useRedirectToCallback';
import useTranslation from 'canvas_states/translation/useTranslation';
import FullWidthBannerWithAction from '../../../atoms/FullWidthBannerWithAction';
import useOnboardCallback from '../../../utils/onboardUpgrade/useOnboardCallback';

interface OnboardFullWidthBannerProps {
  dataTestId?: string;
}
const OnboardFullWidthBanner: React.FC<OnboardFullWidthBannerProps> = ({ dataTestId }) => {
  const { callbackUrl } = useOnboardCallback().states;
  const { redirectToCallback } = useRedirectToCallback().actions;
  const { t } = useTranslation().actions;

  return (
    <FullWidthBannerWithAction
      onClick={async () => await redirectToCallback(callbackUrl)}
      dataTestId={dataTestId}
      text={t('offer.web-check-in.continue-long')}
    />
  );
};
export default OnboardFullWidthBanner;
